import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setExpandDrawerAction,
  resetUserTokenAction,
  handleMenuCollapsed,
} from "@reducers/app.reducer";
import { setMenuListAction } from "@reducers/menu.reducer";
import { updateMenuList } from "@reducers/menu.reducer";
import { getAppModules, sideMenuService } from "./sidemenu.component.service";
import SideMenuTemplateComponent from "./sidemenu-template.component";
import { useState } from "react";
import { APP } from "@constants/app.constants";
import { checkForExpiredToken } from "@screens/system/settings/setting-list/setting.list.service";

import { PRIMARY_KEY } from "@constants/app.constants";

function SideMenuComponent({ setMenuVisibility }) {
  const { theme, expandDrawer, menuCollapsed, token } = useSelector(
    (state) => state?.app
  );
  const { menuList } = useSelector((state) => state?.menu);
  const [moduleList, setModuleList] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [previousMenu, setPrevioudMenu] = useState({
    previousModuleId: null,
    previousMenuId: null,
  });

  const handleShowDrawer = () => {
    dispatch(setExpandDrawerAction(true));
  };

  const handleHideDrawer = () => {
    dispatch(setExpandDrawerAction(false));
  };

  const handleOpenSubMenu = (moduleIndex, index) => {
    let copyModules = [...moduleList];

    copyModules[moduleIndex].menus[index].subMenuOpen =
      !copyModules[moduleIndex].menus[index].subMenuOpen;

    if (
      previousMenu.previousModuleId >= 0 ||
      previousMenu.previousMenuId >= 0
    ) {
      // copyModules[previousMenu.previousModuleId].menus[
      //   previousMenu.previousMenuId
      // ].subMenuOpen = false;
    }

    setPrevioudMenu({ previousModuleId: moduleIndex, previousMenuId: index });

    setModuleList(copyModules);
    // dispatch(updateMenuList({ index, status: !menuList[index].subMenuOpen }));
  };

  const setMenuCollapsed = (value) => {
    dispatch(handleMenuCollapsed(value));
  };

  const currentActiveGroup = (menu, currentPath, index) => {
    if (menu && menu?.sub_menus?.length > 0) {
      const currentRoute = menu.sub_menus.find(
        (item) => currentPath === `/${item.menu_url}`
      );
      if (currentRoute) return true;
      return false;
    }
  };

  const formatModuleMenu = ({ modules, menus }) => {
    // console.log({ modules, menus });
    const moduleArray = [];
    for (let i = 0; i < modules.length; i++) {
      const filteredMenus = menus.filter(
        (menu) => menu.module_id === modules[i][PRIMARY_KEY]
      );
      const moduleData = {
        ...modules[i],
        menus: filteredMenus.map((menu) => {
          return { ...menu, subMenuOpen: false };
        }),
      };
      if (filteredMenus.length > 0) moduleArray.push(moduleData);
    }
    return moduleArray;
  };

  const onLoad = async () => {
    const modules = await getAppModules();
    const menus = await sideMenuService.getMenus();
    if (menus.status) {
      const formattedModuleMenus = formatModuleMenu({
        modules: modules.data,
        menus: menus.data,
      });
      // console.log({ formattedModuleMenus });
      setModuleList(formattedModuleMenus);
      const menuListData = menus.data;
      dispatch(setMenuListAction(menuListData));
    } else if (
      menus.message === "Token expired" ||
      menus.message === "Invalid token"
    ) {
      // Hand this to the shared handler rather than clearing here: on the
      // hosted domain a Hub JWT expiring means "mint another from the still
      // valid session", not "show the local login form to somebody who has
      // no local password". It reloads the menu once the new token lands.
      checkForExpiredToken(menus.message);
    }
  };

  const redirectMainMenu = (menu) => {
    history.push("/" + menu.menu_url);
  };

  // useEffect(() => {
  //   dispatch(updateMenuList({ index: 0, status: false }));
  // }, [location]);

  // Keyed on the token: a Hub JWT that expired and was re-minted lands a new
  // value here, and the menu that failed against the old one loads against
  // the new one. Mount still fires it, because the token is set by then.
  useEffect(() => {
    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <SideMenuTemplateComponent
      templateEvents={{
        handleShowDrawer,
        handleHideDrawer,
        setMenuCollapsed,
        handleOpenSubMenu,
        currentActiveGroup,
        setMenuVisibility,
        redirectMainMenu,
      }}
      templateModal={{
        theme,
        expandDrawer,
        menuList,
        moduleList,
        menuCollapsed,
      }}
    />
  );
}

export default SideMenuComponent;
